// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"562c602e","239":"02c911e8","453":"a36000a9","732":"85b14ccd"}[chunkId] + ".chunk.js";
};